export function injectHotjarTrackingCode() {
    (function (h, o, t, j, a, r) {
        var errorUrl,
            environment,
            environmentID,
            domain,
            host,
            insightsHost,
            insightsApiHost,
            wsHost,
            loc = document.location.host,
            result,
            port,
            siteId,
            staticHost,
            varsHost,
            surveysHost,
            identifyEndpoint,
            viewCounterEndpoint,
            viewCounterHitPercentage,
            surveyImpressionsEndpoint,
            contentHost,
            eventsHost,
            metricsUrl = 'https://pacman-metrics-integration.live.eks.hotjar.com/';

        if (loc === 'insights.hotjar.com') {
            // LIVE.

            // FN-905: Direct Hotjar tracking code injection is disabled for production.
            // The script is installed through Segment.

            return;
        } else {
            result = loc.match(/^(insights-webapp|insights)-(.+)\.(.+)\.eks\.hotjar\.com$/);
            if (result && result[1] === 'insights-webapp') {
                // REVIEW WEBAPP.
                environment = 'staging';
                environmentID = result[2];
                siteId = 14;
                insightsHost = loc;
                insightsApiHost = loc;
                host = 'in-integration.live.eks.hotjar.com';
                wsHost = 'ws1-integration.live.eks.hotjar.com';
                staticHost = 'static-integration.live.eks.hotjar.com';
                varsHost = 'vars-integration.live.eks.hotjar.com';
                surveysHost = 'surveys-webapp-' + environmentID + '.live.eks.hotjar.com';
                errorUrl = 'https://1f207eb734724d2698fcacdeae569a24@sentry.io/1803150';
                viewCounterEndpoint = 'https://vc-staging.hotjar.io/sessions';
                viewCounterHitPercentage = 1.0;
                surveyImpressionsEndpoint = 'https://surveystats-staging.hotjar.io/hit';
                identifyEndpoint = 'https://identify-integration.hotjar.com';
                contentHost = 'pacman-content-integration.live.eks.hotjar.com';
                eventsHost = 'https://pacman-events-integration.live.eks.hotjar.com';
            } else if (result && result[1] === 'insights') {
                // REVIEW / INTEGRATION
                environment = 'staging';
                environmentID = result[2];
                domain = result[3];
                siteId = 14;
                insightsHost = loc;
                insightsApiHost = loc;
                host = 'in-' + environmentID + '.' + domain + '.eks.hotjar.com';
                wsHost = 'ws1-' + environmentID + '.' + domain + '.eks.hotjar.com';
                staticHost = 'static-' + environmentID + '.' + domain + '.eks.hotjar.com';
                varsHost = 'vars-' + environmentID + '.' + domain + '.eks.hotjar.com';
                surveysHost = 'surveys-' + environmentID + '.' + domain + '.eks.hotjar.com';
                errorUrl = 'https://1f207eb734724d2698fcacdeae569a24@sentry.io/1803150';
                viewCounterEndpoint = 'https://vc-staging.hotjar.io/sessions';
                viewCounterHitPercentage = 1.0;
                surveyImpressionsEndpoint = 'https://surveystats-staging.hotjar.io/hit';
                identifyEndpoint = 'https://identify-integration.hotjar.com';
                contentHost = 'pacman-content-integration.live.eks.hotjar.com';
                eventsHost = 'https://pacman-events-integration.live.eks.hotjar.com';
            } else if (loc === 'insights-staging.hotjar.com' || loc === 'staging.jonathor.com') {
                // STAGING.
                environment = 'staging';
                environmentID = 'staging';
                siteId = 14;
                errorUrl = 'https://1f207eb734724d2698fcacdeae569a24@sentry.io/1803150';
                host = 'in-staging.hotjar.com';
                insightsHost = 'insights-staging.hotjar.com';
                insightsApiHost = 'insights-staging.hotjar.com';
                wsHost = 'ws1-staging.hotjar.com';
                staticHost = 'static-staging.hotjar.com';
                varsHost = 'vars-staging.hotjar.com';
                surveysHost = 'surveys-staging.hotjar.com';
                viewCounterEndpoint = 'https://vc-staging.hotjar.io/sessions';
                viewCounterHitPercentage = 1.0;
                surveyImpressionsEndpoint = 'https://surveystats-staging.hotjar.io/hit';
                identifyEndpoint = 'https://identify-integration.hotjar.com';
                contentHost = 'pacman-content-integration.live.eks.hotjar.com';
                eventsHost = 'https://pacman-events-integration.live.eks.hotjar.com';
            } else {
                // DEV / LOCAL.
                environment = 'dev';
                environmentID = 'dev';
                siteId = 14;
                errorUrl = null; // No reporting
                port = location.port !== '' ? ':' + location.port : '';
                host = 'in.local.hotjar.com:8443';
                insightsHost = 'local.hotjar.com' + port;
                insightsApiHost = 'local.hotjar.com:8443';
                wsHost = 'ws.local.hotjar.com:8443';
                staticHost = 'static.local.hotjar.com:8443';
                varsHost = 'vars.local.hotjar.com:9443';
                surveysHost = 'surveys.local.hotjar.com';
                viewCounterEndpoint = null; // No view counting
                surveyImpressionsEndpoint = null; // No impression counting
                identifyEndpoint = 'http://localhost:8000';
                contentHost = 'pacman-content-integration.live.eks.hotjar.com';
                eventsHost = 'https://pacman-events-integration.live.eks.hotjar.com';
            }
        }

        h.hj =
            h.hj ||
            function () {
                (h.hj.q = h.hj.q || []).push(arguments);
            };

        h._hjSettings = {
            hjid: siteId,
            hjsv: 6,
            host: host,
            insightsHost: insightsHost,
            insightsApiHost: insightsApiHost,
            wsHost: wsHost,
            staticHost: staticHost,
            varsHost: varsHost,
            surveysHost: surveysHost,
            errorUrl: errorUrl,
            environment: environment,
            environmentID: environmentID,
            identifyEndpoint: identifyEndpoint,
            viewCounterEndpoint: viewCounterEndpoint,
            viewCounterHitPercentage: viewCounterHitPercentage,
            surveyImpressionsEndpoint: surveyImpressionsEndpoint,
            contentHost: contentHost,
            eventsHost: eventsHost,
            metricsUrl
        };
        a = o.getElementsByTagName('head')[0];
        r = o.createElement('script');
        r.async = 1;
        r.src = 'https://' + staticHost + t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
        a.appendChild(r);
    })(window, document, '/c/hotjar-', '.js?sv=');
}
